import { render, staticRenderFns } from "./dialogAlertaDataLimite.vue?vue&type=template&id=2b60aea1&scoped=true"
import script from "./dialogAlertaDataLimite.vue?vue&type=script&lang=js"
export * from "./dialogAlertaDataLimite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b60aea1",
  null
  
)

export default component.exports